// Options API mixin — do NOT use arrow functions in methods.
export default {
  data: () => ({
      // local state the mixin needs
      drag_source_index: null,
  }),

  methods: {
    drag_start_section(e, index) {
      this.drag_source_index = index;

      if (e.currentTarget) e.currentTarget.style.opacity = "0.6";

      if (e.dataTransfer) {
        e.dataTransfer.effectAllowed = "move";
        // keeps Safari/Firefox happy
        e.dataTransfer.setData("text/plain", String(index));
      }
    },

    drag_over(e) {
      e.preventDefault();
      if (e.dataTransfer) e.dataTransfer.dropEffect = "move";
    },

    drag_end(e) {
      if (e.currentTarget) e.currentTarget.style.opacity = "1";
      this.drag_source_index = null;
    },

    drag_drop_section(e, target_index) {
      e.preventDefault();

      const source_index = this.drag_source_index;
      if (source_index === null || source_index === target_index) return;

      // IMPORTANT: expects the host component to define current_reorder_sections
      const sections = [...this.current_reorder_sections];
      const dragged = sections.splice(source_index, 1)[0];
      sections.splice(target_index, 0, dragged);

      this.current_reorder_sections = sections;
      this.drag_source_index = null;
    },
  },
};
